<div class="d-flex w-100 justify-content-between">
    <h2 mat-dialog-title>
        TVM details
    </h2>
    <button mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <h5 [routerLink]="['/projecten', data.project.id]" [queryParams]="{ ttm: data.ttm.id }">
        TVM #{{data.ttm.id}} - {{data.project.id_4ps ?? data.project.name}}
    </h5>
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">{{(data.ttmTypes | byKey : data.ttm.type_key)?.name}}</h4>
        <mat-chip [style.background-color]="'#' + (data.ttmStatuses | byKey: data.ttm.status_key)?.color">
            {{(data.ttmStatuses | byKey: data.ttm.status_key)?.name}}
        </mat-chip>
    </div>
    <div *ngFor="let entity of data.ttm.entities" class="mb-3">
        <div class="d-flex justify-content-between mb-2">
            <!-- <h4><a href="{{env.apiEndpoint}}api/drawings/generate-svgs/{{entity.drawing_ids[0]}}/{{entity.handle}}">{{entity.handle}}</a></h4> -->
            <h5>{{entity.name}} - {{entity.handle}}</h5>
            <a href="https://maps.google.com/?q={{entity.gnd.coordinates[0][1]}},{{entity.gnd.coordinates[0][0]}}" target="_blank">
                {{entity.gnd.coordinates[0][1] | number : '0.0-3'}}, {{entity.gnd.coordinates[0][0] | number : '0.0-3'}}
            </a>
        </div>
        <div class="d-flex justify-content-evenly">
            <div class="ttm-image" app-svg-as-img [svg]="entity?.plain_image?.svg"></div>
            <div class="ttm-image" app-svg-as-img [svg]="entity?.projected_image?.svg"></div>
            `
            @if (entity?.gnd_image?.svg) {
                <div class="ttm-image" app-svg-as-img [svg]="entity?.gnd_image?.svg"></div>
            }
            <div>
                <pre>{{entity?.attr | json}}</pre>
            </div>
        </div>
    </div>

    @if (form) {
        <div class="d-flex justify-content-between">
            <form [formGroup]="form">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Opmerking</mat-label>
                    <textarea matInput formControlName="comment"></textarea>
                </mat-form-field>
            </form>
        </div>
    }
    <div class="actions d-flex gap-3">
        <button mat-flat-button color="primary" (click)="save()" *ngIf="form">
            <i class="fa fa-save"></i> Opslaan
        </button>

        <button mat-button type="button" (click)="onClose()">Sluiten</button>
    </div>
</mat-dialog-content>
